import Decimal from 'decimal.js';
import { LINE_ITEM_CUSTOMER_COMMISSION } from 'util/types';
import { LINE_ITEM_PROVIDER_COMMISSION } from 'util/types';

import { types as sdkTypes } from 'util/sdkLoader';

const { Money } = sdkTypes;

/**
 * Calculates the total price in sub units for multiple line items.
 */
const lineItemsTotal = (lineItems, marketplaceCurrency) => {
  const amount = lineItems.reduce((total, item) => {
    return total.plus(item.lineTotal.amount);
  }, new Decimal(0));
  const currency = lineItems[0] ? lineItems[0].lineTotal.currency : marketplaceCurrency;
  return new Money(amount, currency);
};

/**
 * Checks if line item represents commission
 */
const isCommission = (lineItem) => {
  return (
    lineItem.code === LINE_ITEM_PROVIDER_COMMISSION ||
    lineItem.code === LINE_ITEM_CUSTOMER_COMMISSION
  );
};

/**
 * Returns non-commission, non-reversal line items
 */
const nonCommissionNonReversalLineItems = (lineItems) => {
  return lineItems.filter((item) => !isCommission(item) && !item.reversal);
};

const calculateSubTotal = ({ lineItems, currency }) => {
  // all non-reversal, non-commission line items
  const subTotalLineItems = nonCommissionNonReversalLineItems(lineItems);
  // line totals of those line items combined
  const subTotal = lineItemsTotal(subTotalLineItems, currency);
  return subTotal;
};

export default calculateSubTotal;
